<script setup>
  import { defineProps, computed } from 'vue'
  import { cssify } from '@/utilities';

  const props = defineProps({
    tool: String,
  });

  const toolUrl = computed(()=>{
    if (props.tool == "Home"){
      return ''
    }
    return cssify(props.tool);
  });

  const classes = computed(()=>{
    if (props.tool == "Home"){
      return 'tool-home text-primary hover:bg-primary/10 hover:border-primary';
    }
    return 'tool-'+toolUrl.value+' text-tool-'+toolUrl.value+' hover:bg-tool-'+toolUrl.value+'/10 hover:border-tool-'+toolUrl.value+'';
  });

</script>
<template>
  <router-link
    :to="'/'+toolUrl"
    :class="[
      'flex items-center border-b-4 border-white dark:border-gray-900 px-4',
      classes
    ]"
  >
    <div>{{ tool }}</div>
  </router-link>
</template>
